import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

function LanguageSwitcher({ className = "" }) {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      onClick={toggleLanguage}
      variant="outline"
      size="sm"
      className={`border-border hover:border-primary hover:text-primary bg-transparent gap-1 ${className}`}
    >
      <Globe size={14} />
      {language === 'ru' ? 'EN' : 'RU'}
    </Button>
  );
}

export default LanguageSwitcher;
